import { useState } from 'react';
import { Card, CardHeader } from '../../../../components/ui/Card';
import { Badge } from '../../../../components/ui/Badge';
import { useUrlReport } from '../../../../hooks/useVisibility';
import { useFilters } from '../filters';
import { Table, THead, Th, Td } from '../../../../components/ui/Table';
import { EmptyState, LoadingState } from '../../../../components/ui/States';

export function SourcesUrlsPage() {
  const { startDate, endDate } = useFilters();
  const [gap, setGap] = useState(false);
  const { data, isLoading } = useUrlReport(startDate, endDate, { gap });

  return (
    <Card padding="md">
      <CardHeader
        title={gap ? 'Gap URLs' : 'Top URLs'}
        description={gap ? 'Specific pages competitors cite that we don\'t' : 'Most-cited URLs across all AI engines'}
        action={
          <label className="flex items-center gap-2 text-body-sm">
            <input type="checkbox" checked={gap} onChange={(e) => setGap(e.target.checked)} />
            Gap only
          </label>
        }
      />
      {isLoading ? (
        <LoadingState />
      ) : !data || data.rows.length === 0 ? (
        <EmptyState compact title="No URL data." />
      ) : (
        <div className="overflow-x-auto">
          <Table>
            <THead>
              <tr>
                <Th className="px-3">URL</Th>
                <Th className="px-3">Type</Th>
                <Th align="right" className="px-3">Retrieved</Th>
                <Th align="right" className="px-3">Citations</Th>
              </tr>
            </THead>
            <tbody>
              {data.rows.slice(0, 100).map((row, i) => {
                const url = row[data.columns.indexOf('url')] as string;
                return (
                  <tr key={i} className="border-t border-border-light">
                    <Td className="px-3 max-w-md">
                      <a href={url} target="_blank" rel="noreferrer" className="text-info-dark hover:text-info underline-offset-2 hover:underline truncate block" title={url}>
                        {url}
                      </a>
                    </Td>
                    <Td className="px-3">
                      <Badge>{(row[data.columns.indexOf('url_classification')] as string) ?? '—'}</Badge>
                    </Td>
                    <Td align="right" className="px-3 tabular-nums">{row[data.columns.indexOf('retrieval_count')]}</Td>
                    <Td align="right" className="px-3 tabular-nums">{row[data.columns.indexOf('citation_count')]}</Td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      )}
    </Card>
  );
}
